import styled from 'styled-components';

export const EditIndicator = styled.div`
  position: absolute;
  right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  border-radius: 12px;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  opacity: 0;
  transform: translateX(4px);
  transition: opacity 0.2s ease, transform 0.2s ease;
  pointer-events: none;
`;

export const Div = styled.div<{ $itemHeight: number }>`
  outline: none;
  background: transparent;
  position: relative;
  height: ${({ $itemHeight }) => $itemHeight}px;

  &:hover,
  &:focus-within {
    background: ${({ theme }) => theme.colors.cultured};
  }

  &:hover ${EditIndicator} {
    opacity: 1;
    transform: translateX(0);
  }

  &:focus-within {
    outline: 1px solid ${({ theme }) => theme.colors.stroke};
  }

  &:focus-within ${EditIndicator} {
    opacity: 1;
    transform: translateX(0);
  }

  display: flex;
  align-items: center;

  tr[data-expanded='true'] & {
    margin-bottom: 1px;
  }

  .cydea-select {
    min-width: 0 !important;
    width: 100% !important;
    height: 100%;
  }
  .cydea-select__control {
    height: 100% !important;
    min-height: unset !important;
    border: none !important;
    background: transparent !important;
  }
  .cydea-select__value-container {
    padding: 0 14px !important;
  }
  .cydea-select__dropdown-indicator {
    display: none;
  }

  input,
  textarea,
  .MuiInputBase-root {
    background: transparent !important;
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    height: ${({ $itemHeight }) => $itemHeight * 0.8}px;
  }
  ${({ theme }) => theme.breakpoints.down('sm')} {
    height: ${({ $itemHeight }) => $itemHeight * 0.6}px;
  }
`;
